module.exports = __webpack_public_path__ + "img/modular_settlement_submit_yellow@2x.6ad97b6c.png";